var map = {
	"./donny-pizza.png": 8638,
	"./eric-sad.png": 58,
	"./jimplayers.png": 9186,
	"./jon-happy.jpg": 3351,
	"./kg-diving-catch.png": 2949,
	"./kgmeeting.png": 9701,
	"./last-dance.png": 8716,
	"./sorry-no-image.jpeg": 4661,
	"./steve and jason.png": 8662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3788;